import React from "react";
import "../StatusChip/StatusChip.scss";

const StatusChip = ({ status }) => {
  
  const getRectangleCss = (status) => {
   
    switch (status) {
      case "COMPLETE":
        return "rectangle-green";
      case "VOID":
        return "rectangle-red";
      case "PENDING":
        return "rectangle-yellow";

      default:
        return "";
    }
  };
  const getCircleCss = (status) => {
    switch (status) {
      case "COMPLETE":
        return "circle-green";
      case "VOID":
        return "circle-red";

      case "PENDING":
        return "circle-yellow";

      default:
        return "";
    }
  };
  const getStatusCss = (status) => {
    switch (status) {
      case "COMPLETE":
        return "status-green";
      case "VOID":
        return "status-red";
      case "PENDING":
        return "status-yellow";

      default:
        return "";
    }
  };
  const getStatusCamelCase = (status) => {
        switch (status) {
          case "COMPLETE":
            return "Complete";
          case "VOID":
            return "Void";
          case "PENDING":
            return "Pending";
    
          default:
            return "";
        }
      };

  return (
    <>
      <div className={getRectangleCss(status)}>
        <div className={getCircleCss(status)}></div>
        <div className={getStatusCss(status)}>{getStatusCamelCase(status)}</div>
      </div>
    </>
  );
};

export default StatusChip;
